<template>
  <div class="about">
    <div class="content">
      <cpt-header></cpt-header>
      <cpt-structure></cpt-structure>
      <cpt-background></cpt-background>
      <div :class="$utils.isMobile() ? 'about-banner-m' : 'about-banner'">
        <img class="back" src="../../assets/about-bg3-en.png" v-if="$i18n.locale == 'en-US'" alt="">
        <img class="back" src="../../assets/about-bg3.png" v-else alt="">
      </div>
      <cpt-sh></cpt-sh>
      <cpt-core></cpt-core>
      <cpt-bottom></cpt-bottom>
    </div>
    <cpt-change-lang></cpt-change-lang>
  </div>
</template>

<script>
import cptHeader from '../../components/header/cpt-header.vue';
import cptBottom from '../../components/cpt-bottom.vue';
import cptStructure from '../../components/cpt-structure.vue';
import cptBackground from '../../components/cpt-background.vue';
import cptSh from '../../components/cpt-sh.vue';
import cptCore from '../../components/cpt-core.vue'
import cptChangeLang from '../../components/cpt-change-lang.vue';
export default {
  components: {
    cptHeader,
    cptBottom,
    cptStructure,
    cptBackground,
    cptSh,
    cptCore,
    cptChangeLang
  },
  data() {
    return {
    }
  },
  mounted(){
    window.scrollTo(0, 0)
  },
  methods: {

  },
}

</script>

<style lang='scss' scoped>
.about{
  .content{
    width: 100%;
    .about-banner{
      width: 100%;
      display: flex;
      .back{
        width: 100%;
        min-height: 175px;
      }
    }
    .about-banner-m{
      // width: 100%;
      padding: 15px;
      overflow: hidden;
      display: flex;
      .back{
        width: 100%;
        min-height: 115px;
        border-radius: 3px;
        object-position: -50px 0;
      }
    }
  }
}
</style>